import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
interface CountdownProps {
  tone?: 'light' | 'dark';
  label?: string;
}
export function Countdown({
  tone = 'light',
  label = 'THIS OFFER ENDS IN'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const boxClass = tone === 'dark' ? 'bg-white/10 text-white ring-1 ring-white/20' : 'bg-navy text-white ring-1 ring-navy/20';
  const labelClass = tone === 'dark' ? 'text-white/70' : 'text-ink/55';
  const unitClass = tone === 'dark' ? 'text-white/60' : 'text-ink/50';
  const units = [{
    v: pad(hours),
    u: 'HOURS'
  }, {
    v: pad(minutes),
    u: 'MIN'
  }, {
    v: pad(seconds),
    u: 'SEC'
  }];
  return <div className="w-full text-center" data-id="element-19" data-mp="t2lh70nlz3xi">
      <p className={`text-[11px] font-bold uppercase tracking-[0.18em] ${labelClass}`} data-id="element-20" data-mp="t1tn5u9nte9c">{label}</p>
      <div className="mt-2 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-21" data-mp="17q6m9041nd82">
        {units.map(unit => <div key={unit.u} className="flex flex-col items-center" data-id="element-22" data-mp="f2aso49ru1fi">
            <div className={`min-w-[64px] rounded-xl px-3 py-2 font-display text-3xl font-bold tabular-nums sm:min-w-[76px] sm:text-4xl ${boxClass}`} data-id="element-23" data-mp="f2kkzyiagkod">
              {unit.v}
            </div>
            <span className={`mt-1 text-[10px] font-bold uppercase tracking-widest ${unitClass}`} data-id="element-24" data-mp="o0nufwg01qzt">
              {unit.u}
            </span>
          </div>)}
      </div>
    </div>;
}